<template>
  <div>
    <download-excel :data="filteredBrands" :fields="json_fields">
      <v-btn color="blue" dark style="float: right;">
        <span class="pr-3">Download Excel</span>
        <v-icon>file_download</v-icon>
      </v-btn>
    </download-excel>
    <v-data-table
      class="elevation-5"
      :headers="headers"
      :items="filteredBrands"
      :loading="loadingBrands"
      :no-data-text="noDataText"
      :pagination.sync="pagination"
      :search="brandsSearch"
    >
      <template #items="{ item }">
        <tr @click="goToPivotsView(item)" style="cursor: pointer">
          <td>{{ item.name }}</td>
          <td class="text-xs-right">
            {{ item.kpis.clientsQMIs.toLocaleString() }}
          </td>
          <td class="text-xs-right">
            {{ item.kpis.clientsQMIsWithoutQMP.toLocaleString() }}
          </td>
          <td class="text-xs-right">
            {{ item.kpis.competitorsQMIs.toLocaleString() }}
          </td>
          <td class="text-xs-right">
            {{ item.kpis.competitorsQMIsWithoutQMP.toLocaleString() }}
          </td>
          <td class="text-xs-center">
            {{
              item.searcher
                ? formatDatetime(item.searcher.created)
                : "No tiene índice creado"
            }}
          </td>
          <td class="text-xs-center">
            {{
              item.searcher
                ? item.searcher.finished
                  ? formatDatetime(item.searcher.finished)
                  : "No ha terminado aún"
                : "No tiene índice creado"
            }}
          </td>
          <td v-if="item.searcher" class="text-xs-center">
            <v-confirmation-dialog
              @confirm="createIndex(item)"
              text="¿Estás seguro que quieres actualizar el índice?"
            >
              <template #activator="{ on }">
                <v-btn v-on="on" @click.stop color="blue" dark small>
                  <v-icon>cached</v-icon>
                  <span class="ml-2">Actualizar índice</span>
                </v-btn>
              </template>
            </v-confirmation-dialog>
          </td>
          <td v-else class="text-xs-center">
            <v-confirmation-dialog
              @confirm="createIndex(item)"
              text="¿Estás seguro de que quieres crear el índice?"
            >
              <template #activator="{ on }">
                <v-btn v-on="on" @click.stop color="green" dark small>
                  <v-icon>add</v-icon>
                  <span class="ml-2">Crear índice</span>
                </v-btn>
              </template>
            </v-confirmation-dialog>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import VConfirmationDialog from "@/components/confirmations/ConfirmationDialog";

export default {
  components: {
    VConfirmationDialog,
  },
  data: () => ({
    headers: [
      {
        text: "Marca",
        value: "name",
        align: "left",
        sortable: true,
      },
      {
        text: "# QMIs de clientes",
        value: "kpis.clientsQMIs",
        align: "right",
        sortable: true,
      },
      {
        text: "# QMIs sin QMP de clientes",
        value: "kpis.clientsQMIsWithoutQMP",
        align: "right",
        sortable: true,
      },
      {
        text: "# QMIs de competidores",
        value: "kpis.competitorsQMIs",
        align: "right",
        sortable: true,
      },
      {
        text: "# QMIs sin QMP de competidores",
        value: "kpis.competitorsQMIsWithoutQMP",
        align: "right",
        sortable: true,
      },
      {
        text: "Fecha creación índice",
        align: "center",
        sortable: false,
      },
      {
        text: "Fecha término creación",
        align: "center",
        sortable: false,
      },
      {
        text: "Crear índice",
        align: "center",
        sortable: false,
      },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: "kpis.clientsQMIsWithoutQMP",
    },
    json_fields: {
      Clasificación: "name",
      "# QMIs de clientes": "kpis.clientsQMIsWithQMP",
      "# QMIs sin QMP de clientes": "kpis.clientsQMIsWithoutQMP",
      "# QMIs de competidores": "kpis.competitorsQMIsWithQMP",
      "# QMIs sin QMP de competidores": "kpis.competitorsQMIsWithoutQMP",
    },
  }),
  computed: {
    ...mapState("matching", ["brands", "brandsSearch", "loadingBrands"]),
    classificationId() {
      return this.$route.params.classificationId;
    },
    noDataText() {
      return this.loadingBrands
        ? "Cargando marcas"
        : "No hay marcas que mostrar";
    },
    filteredBrands() {
      var matchingStore = this.$store.state["matching"];

      if (!matchingStore.showOnlyPendingClassifications) return this.brands;

      return this.brands.filter(({ kpis }) => {
        return kpis.clientsQMIsWithoutQMP > 0;
      });
    },
  },
  created() {
    this.getBrands();
  },
  methods: {
    ...mapActions("matching", {
      createIndexAction: "createIndex",
      getBrandsAction: "getBrands",
    }),
    createIndex(brand) {
      return this.createIndexAction({
        brand: brand.name,
        classificationId: this.classificationId,
      });
    },
    formatDatetime(datetime) {
      const [date, time] = datetime.split("T");
      return `${date} ${time.slice(0, -4)}`;
    },
    getBrands() {
      return this.getBrandsAction({
        classificationId: this.classificationId,
      });
    },
    goToPivotsView(brand) {
      // if (!brand.searcher) {
      //   return this.$notify.error("Esta marca aún no tiene índice");
      // }

      return this.$router.push({
        name: "matching/pivots",
        params: {
          classificationId: this.classificationId,
          brandName: brand.name,
        },
      });
    },
  },
};
</script>
